import type { CreatePreset, CreateWorld, Preset, World, ApiError } from '@wg/shared';

const BASE = '/api';

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${BASE}${path}`, {
    ...init,
    credentials: 'include',
    headers: { 'content-type': 'application/json', ...(init?.headers ?? {}) },
  });
  if (!res.ok) {
    let err: ApiError = { error: { code: 'unknown', message: res.statusText } };
    try { err = (await res.json()) as ApiError; } catch { /* ignore */ }
    throw new ApiRequestError(err.error.code, err.error.message, res.status);
  }
  if (res.status === 204) return undefined as T;
  return (await res.json()) as T;
}

export class ApiRequestError extends Error {
  constructor(public code: string, message: string, public status: number) { super(message); }
}

export const api = {
  presets: {
    create: (body: CreatePreset) => request<{ id: string }>('/presets', { method: 'POST', body: JSON.stringify(body) }),
    list: () => request<Preset[]>('/presets'),
    get: (id: string) => request<Preset>(`/presets/${id}`),
    remove: (id: string) => request<void>(`/presets/${id}`, { method: 'DELETE' }),
  },
  worlds: {
    create: (body: CreateWorld) => request<{ slug: string }>('/worlds', { method: 'POST', body: JSON.stringify(body) }),
    get: (slug: string) => request<World>(`/worlds/${slug}`),
  },
};
